import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emb-card" }
const _hoisted_2 = { class: "emb-card_body" }
const _hoisted_3 = {
  class: "printmap-title",
  for: "schedule visit"
}
const _hoisted_4 = {
  class: "printmap-desc form-group",
  for: "schedule visit"
}
const _hoisted_5 = {
  class: "printmap-title",
  for: "print map"
}
const _hoisted_6 = {
  class: "printmap-desc form-group",
  for: "print map"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  key: 0,
  class: "form-group"
}
const _hoisted_12 = {
  key: 1,
  class: "form-group"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-group sv-form" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 2,
  class: "form-group form-check"
}
const _hoisted_18 = {
  class: "form-check-label",
  for: "virtualtour"
}
const _hoisted_19 = { class: "form-group form-check" }
const _hoisted_20 = {
  class: "form-check-label",
  for: "iamrealtor"
}
const _hoisted_21 = { class: "form-group form-check" }
const _hoisted_22 = {
  class: "form-check-label",
  for: "newsletter"
}
const _hoisted_23 = { class: "form-group text-center" }
const _hoisted_24 = ["disabled"]

import { ref, reactive, toRefs, onMounted } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { isMobile, isTablet } from 'mobile-device-detect';
import { apiSaveLead, apiPrintPDF } from './../../api';
import { ModalType, Settings, TimeSlots } from './../../constant';
import { LeadData, LotInfo, PrintRequest } from './../../types';
import Calendar from './../Calendar.vue';
import html2canvas from 'html2canvas';
import { apiMessages } from '../../api/message-api';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactInformation',
  props: {
    printOptionSelected: { type: Boolean },
    showModal: { type: Boolean },
    neighborhoodAreaName: {},
    areaId: {},
    neighborhoodName: {},
    neighborhoodId: {},
    topPosition: {},
    legends: {}
  },
  emits: ['closeModal', 'openModal', 'openPrintModal'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { printOptionSelected, neighborhoodAreaName, areaId, neighborhoodName, neighborhoodId, topPosition, showModal, legends } = toRefs(props);
const emits = __emit;

const firstName = ref('');
const lastName = ref('');
const email = ref('');
const confirmEmail = ref('');
const questions = ref('');
const message: any = ref({});
const isRequiredMessages: any = ref({});
const marketingOptIn = ref(false);
const isRealtor = ref(false);
const isVirtualTour = ref(false);
const selectedTimeSlot = ref('');
const errors = ref<string[]>();
const loading = ref(false);
const timeSlots = TimeSlots;

const calender = ref(null as any);

const loadMessages = async () => {
  const { messages, validationMessage } = await apiMessages('ContactInformation');
  message.value = messages;
  isRequiredMessages.value = validationMessage;
};

const closeModal = (modalName) => {
  emits('closeModal', modalName);
};

const openPrintModal = () => {
  emits('openPrintModal');
};

const submitData = (e) => {
  e.preventDefault();
  loading.value = true;
  errors.value = [];
  let timer = setTimeout(async (_) => {
    await submitContactInfo(e);
    clearTimeout(timer);
  }, 1);
};

const submitContactInfo = async (e) => {
  loading.value = true;
  validateName();
  validateEmail();
  !printOptionSelected.value && validateDateTime();
  if (!errors.value?.length) {
    await submitForm();
  } else loading.value = false;
};

const validateName = () => {
  isEmptyField(firstName.value, isRequiredMessages.value.firstName);
  isNameValid(firstName.value, isRequiredMessages.value.validFirstName, 0);
  isEmptyField(lastName.value, isRequiredMessages.value.lastName);
  isNameValid(lastName.value, isRequiredMessages.value.validLastName, 2);
};

const validateEmail = () => {
  isEmptyField(email.value, isRequiredMessages.value.email);
  isEmptyField(confirmEmail.value, isRequiredMessages.value.confirmEmail);
  if (email.value && !validEmail(email.value)) {
    errors.value?.push(isRequiredMessages.value.validEmail);
  }
  if (email.value && email.value !== confirmEmail.value) {
    errors.value?.push(isRequiredMessages.value.emailMismatch);
  }
};

const validateDateTime = () => {
  if (!calender.value.date) {
    errors.value?.push(isRequiredMessages.value.requiredDate);
  }
  if (!selectedTimeSlot.value) {
    errors.value?.push(isRequiredMessages.value.requiredTime);
  }
};

const isNameValid = (field, fieldText, minimumLength) => {
  if (field && isOnlyCharacter(field, fieldText) && field.length < minimumLength) {
    errors.value?.push(isRequiredMessages.value.validLastName2);
  }
};

const isOnlyCharacter = (field, fieldText) => {
  let isValid = true;
  if (field && !/^[a-zA-Z]+$/.test(field)) {
    isValid = false;
    errors.value?.push(fieldText);
  }
  return isValid;
};

const isEmptyField = (field, fieldText) => {
  if (!field) {
    errors.value?.push(fieldText);
  }
};

const submitForm = async () => {
  try {
    const dates = !printOptionSelected.value ? calender.value.date : '';
    const leadObject: LeadData = {
      areaId: fixAreaName(neighborhoodAreaName.value),
      firstName: firstName.value,
      lastName: lastName.value,
      emailAddress: email.value,
      commentsQuestions: getCommentQuestion(dates),
      marketingOptIn: marketingOptIn.value,
      isRealtor: isRealtor.value,
      preferredVisitDates: dates,
      source: 'Sales Plat',
      timestamp: new Date(),
      leadType: 'RI: Find a New Home',
      urlRef: window.location.href,
    };
    const response = await apiSaveLead(leadObject);
    window.sessionStorage.setItem(Settings.SESSION_KEY, 'Submitted');
    handleResponse(response);
  } catch (error) {
    loading.value = false;
    errors.value = [];
    errors.value?.push(message.value.errorMessage);
  }
};

const fixAreaName = (areaName) => {
  let newAreaName = areaName;
  if (newAreaName.toLowerCase().includes('wash')) {
    newAreaName = 'Drees Washington DC';
  }
  return newAreaName;
};

const getCommentQuestion = (dates) => {
  return printOptionSelected.value ? questions.value : getCommentQuestionByDates(dates);
};

const getCommentQuestionByDates = (dates) => {
  let commentString = `Want to visit ${dates} ${selectedTimeSlot.value}`;
  if (questions.value) {
    commentString += ` | ${questions.value}`;
  }
  if (isVirtualTour.value) {
    commentString += ` | Virtual Tour requested`;
  }
  return commentString;
};

const clearData = () => {
  firstName.value = '';
  lastName.value = '';
  email.value = '';
  confirmEmail.value = '';
  questions.value = '';
  marketingOptIn.value = false;
  isRealtor.value = false;
  isVirtualTour.value = false;
  selectedTimeSlot.value = '';
  errors.value = [];
};

const validEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const handleResponse = (response) => {
  clearData();
  loading.value = false;
  closeModal(ModalType.CONTACT_INFO);
  if (response && printOptionSelected.value) {
    openPrintModal();
  }
};

const handleClose = () => {
  clearData();
  closeModal(ModalType.CONTACT_INFO);
};

onMounted(async () => {
  await loadMessages();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    name: "contact-information",
    modelValue: _unref(showModal),
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null)),
    clickToClose: false,
    "content-style": { maxHeight: '100vh', overflowY: 'auto' },
    width: "100%",
    height: "100%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['printmap', { 'is-print': _unref(printOptionSelected) }]),
        style: _normalizeStyle({ top: `${_unref(topPosition)}px` })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("i", {
            "aria-label": "close icon",
            class: "emb_closeicon is-gray",
            onClick: handleClose
          }),
          _createElementVNode("div", _hoisted_2, [
            (!_unref(printOptionSelected))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h3", _hoisted_3, _toDisplayString(message.value.h3Message), 1),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(message.value.contactMessage), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("h3", _hoisted_5, _toDisplayString(message.value.printH3Message), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(message.value.dreesMessage), 1)
                ], 64)),
            _createElementVNode("form", {
              onSubmit: submitData,
              novalidate: ""
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firstName).value = $event)),
                  name: "firstName",
                  placeholder: "First Name",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, firstName.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastName).value = $event)),
                  name: "lastName",
                  placeholder: "Last Name",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, lastName.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                  name: "email",
                  placeholder: "Email Address",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, email.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmEmail).value = $event)),
                  name: "confirm-email",
                  placeholder: "Confirm Email Address",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, confirmEmail.value]
                ])
              ]),
              (!_unref(printOptionSelected))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", null, "Desired Appointment Time: ", -1)),
                    _createVNode(Calendar, {
                      ref_key: "calender",
                      ref: calender
                    }, null, 512)
                  ]))
                : _createCommentVNode("", true),
              (!_unref(printOptionSelected))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("select", {
                      id: "time",
                      name: "time",
                      class: "form-time-control form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedTimeSlot).value = $event))
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Choose a time", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeSlots), (slot, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: slot,
                          key: idx
                        }, _toDisplayString(slot), 9, _hoisted_13))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, selectedTimeSlot.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "Comments",
                  cols: "30",
                  rows: "4",
                  maxlength: "255",
                  placeholder: _unref(printOptionSelected) ? message.value.printCommentPlaceholder : message.value.commentPlaceholder,
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((questions).value = $event))
                }, null, 8, _hoisted_15), [
                  [_vModelText, questions.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "is-error",
                    key: error
                  }, " · " + _toDisplayString(error), 1))
                }), 128))
              ]),
              (!_unref(printOptionSelected))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "virtualtour",
                      value: "Virtual Tour",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isVirtualTour).value = $event))
                    }, null, 512), [
                      [_vModelCheckbox, isVirtualTour.value]
                    ]),
                    _createElementVNode("label", _hoisted_18, _toDisplayString(message.value.labelForVirtualTour), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "iamrealtor",
                  value: "I am A Realtor",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isRealtor).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, isRealtor.value]
                ]),
                _createElementVNode("label", _hoisted_20, _toDisplayString(message.value.labelForRealtor), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "newsletter",
                  value: "Email marketing",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((marketingOptIn).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, marketingOptIn.value]
                ]),
                _createElementVNode("label", _hoisted_22, _toDisplayString(message.value.labelForNewsLetter), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "btn",
                  disabled: loading.value
                }, [
                  _cache[12] || (_cache[12] = _createTextVNode(" Submit ", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(!!loading.value ? 'loading' : 'icon icon-right-white-arrow')
                  }, null, 2)
                ], 8, _hoisted_24)
              ])
            ], 32)
          ])
        ])
      ], 6)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})